import { NavCard, NavCardSkeleton } from '../../../components/common/NavCard';
import { PageContainer } from '../../../components/layout/page/PageContainer';
import { PageContainerTitle } from '../../../components/layout/page/PageContainerTitle';
import { useCommunityLinks } from '../../../hooks/useCommunityLinks';

const FindCommunity = () => {
  const { links, loading } = useCommunityLinks();

  return (
    <PageContainer>
      <PageContainerTitle
        title="커뮤니티 찾기"
        description="어떤 커뮤니티를 찾고 계신가요?"
      />

      {/* 커뮤니티 링크 카드 목록 */}
      <div className="mt-5 grid grid-cols-1 gap-4 px-[20px] lg:mt-9 lg:grid-cols-3 xl:px-0">
        {loading
          ? Array.from({ length: 3 }, (_, i) => <NavCardSkeleton key={i} />)
          : links.map((item) => (
              <NavCard
                key={item.id}
                to={item.linkUrl}
                imageSrc={item.iconImageUrl ?? undefined}
                topText={item.description ?? undefined}
                bottomText={item.name}
                blank
              />
            ))}
      </div>
    </PageContainer>
  );
};

export default FindCommunity;
